<template>
  <div class="bg-white position-relative overflow-hidden" role="main">
    <section>
      <div class="section-text-box section-text-box-no-bg pt-5">
        <div class="container">
          <div class="row justify-content-md-center">
            <div class="col-12">
              <!-- <h2 class="heading-section-color-bg text-capitalize fw-bold">{{ section_title }}</h2> -->
              <div class="row">
                <div class="col-12 col-lg-4 col-sm-12 mb-4">
                  <calendar />
                </div>
                <div class="col-12 col-lg-8 col-sm-12 mb-4 banner-event">
                  <carousel :root="root" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import calendar from './calendar.vue'
import carousel from './carousel.vue'

export default {
  components: {
    calendar,
    carousel
  },

  props: {
    root: String
  },

  data () {
    return { }
  }
}
</script>

<style scoped>
</style>
